import React, {
    Component
} from 'react';
import {
    CartesianGrid,
    Legend,
    Line,
    LineChart,
    RadialBar,
    RadialBarChart,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis
} from 'recharts';
import {
    Card
} from '@material-ui/core';
export const data = [{
        name: 'Let A',
        uv: 0
    },
    {
        name: 'Let B',
        uv: 30
    },
    {
        name: 'Let C',
        uv: 20
    },
    {
        name: 'Let D',
        uv: 27
    },
    {
        name: 'Let E',
        uv: 18
    },
    {
        name: 'Let F',
        uv: 23
    },
    {
        name: 'Let G',
        uv: 0
    }
];

export class DashboardLineChart extends Component {
    constructor(props) {
        super();
    }
    render() {
        return ( <
            div >
            <
            Card >
            <
            LineChart width = {
                800
            }
            height = {
                250
            }
            data = {
                this.props.data
            } >
            <
            XAxis dataKey = "x" / >
            <
            YAxis / >
            <
            CartesianGrid stroke = "#eee"
            strokeDasharray = "5 5" / >
            <
            Line type = "monotone"
            dataKey = "y"
            stroke = {
                this.props.theme.palette.primary.main
            }
            /> < /
            LineChart > <
            /Card> < /
            div >
        );
    }
}

export default DashboardLineChart;


// WEBPACK FOOTER //
// ./src/components/Chart/DashboardLineChart.js